import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { charterSelector } from '../../../../../../../store/reducers/charterSlice/charterSlice';
import { positionSelector } from '../../../../../../../store/reducers/positionSlice/positionSlice';
import { WeeksModeCharter } from '../WeeksModeCharter/WeeksModeCharter';
import { WeeksModePosition } from '../WeeksModePosition/WeeksModePosition';

export const WeekModeStageChild = ({ childGuid }) => {
    const charters = useSelector(charterSelector.selectEntities);
    const positions = useSelector(positionSelector.selectEntities);

    const chartersGuids = useSelector(charterSelector.selectIds);

    const isCharter = chartersGuids.includes(childGuid);
    return (
        <>
            {isCharter ? (
                <WeeksModeCharter charter={charters[childGuid]} />
            ) : (
                <WeeksModePosition position={positions[childGuid]} />
            )}
        </>
    );
};
